import {
    DontIncludeMostRecentAttachments,
    IncludeMostRecentAttachmentAddedRecipient_MultipleRecipientsText,
    IncludeMostRecentAttachmentAddedRecipient_SingleRecipientText,
    SuggestIncludeMostRecentAttachment_MultipleAttachmentsText,
    SuggestIncludeMostRecentAttachment_SingleAttachmentText,
} from './includeMostRecentAttachmentsInfoBarMessage.locstring.json';
import loc, { format } from 'owa-localize';
import createAttachmentsFromRecentAttachments from './AttachmentQueueManager/createAttachmentsFromRecentAttachments';
import AttachmentWellViewState from '../schema/AttachmentWellViewState';
import { logUsage } from 'owa-analytics';
import { ClientItemId } from 'owa-client-ids';
import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';
import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import Message from 'owa-service/lib/contract/Message';

import {
    InfoBarMessageViewState,
    InfoBarCustomAction,
    InfoBarMessageSource,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export const INCLUDE_MOST_RECENT_ATTACHMENTS_MESSAGEID: string =
    'InfoIncludeMostRecentAttachmentsMessage';

export interface RecipientsCollection {
    toRecipients: ReadWriteRecipientViewState[];
    ccRecipients: ReadWriteRecipientViewState[];
    bccRecipients: ReadWriteRecipientViewState[];
}

export function includeMostRecentAttachmentsInfoBarMessage(
    itemId: ClientItemId,
    message: Message,
    attachmentWell: AttachmentWellViewState,
    recipientNameAdded: string,
    numberOfAddedRecipients: number,
    infoBarAddHandler: (
        messageId: string,
        infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
    ) => void,
    infoBarRemoveHandler: (infoBarMessageIds: string[]) => void,
    updateActedComposeCallback: () => void,
    filterAttachmentsBasedOnAttachmentPolicy: (attachment) => boolean
) {
    const attatchmentsMessageString = getAddedRecipientAttachmentsInfoBarString(
        numberOfAddedRecipients,
        recipientNameAdded
    );
    const infoBarMessageViewState: InfoBarMessageViewState = {
        key: INCLUDE_MOST_RECENT_ATTACHMENTS_MESSAGEID,
        source: InfoBarMessageSource.Compose,
        rank: null,
        message: attatchmentsMessageString,
        messageParts: [attatchmentsMessageString],
    };

    infoBarMessageViewState.messageParts.push(
        getIncludeMostRecentAttachmentsInfoBarAction(
            itemId,
            attachmentWell,
            message,
            infoBarAddHandler,
            infoBarRemoveHandler,
            updateActedComposeCallback,
            filterAttachmentsBasedOnAttachmentPolicy
        )
    );
    infoBarMessageViewState.messageParts.push('|');
    infoBarMessageViewState.messageParts.push(
        getDoNotIncludeMostRecentAttachmentsInfoBarAction(
            infoBarRemoveHandler,
            updateActedComposeCallback
        )
    );

    infoBarAddHandler(INCLUDE_MOST_RECENT_ATTACHMENTS_MESSAGEID, () => infoBarMessageViewState);
}

function getDoNotIncludeMostRecentAttachmentsInfoBarAction(
    infoBarRemoveHandler: (infoBarMessageIds: string[]) => void,
    updateActedComposeCallback: () => void
): InfoBarCustomAction {
    return {
        text: loc(DontIncludeMostRecentAttachments),
        action: () => {
            updateActedComposeCallback();
            infoBarRemoveHandler([INCLUDE_MOST_RECENT_ATTACHMENTS_MESSAGEID]);
            logUsage('AttachmentDoNotIncludeMostRecentAttachments');
        },
    };
}

function getAddedRecipientAttachmentsInfoBarString(
    numberOfAddedRecipients: number,
    recipientNameAdded: string
): string {
    const recipientAddedNotificatioMessage: string =
        numberOfAddedRecipients > 1
            ? format(
                  loc(IncludeMostRecentAttachmentAddedRecipient_MultipleRecipientsText),
                  numberOfAddedRecipients
              )
            : format(
                  loc(IncludeMostRecentAttachmentAddedRecipient_SingleRecipientText),
                  recipientNameAdded
              );

    return recipientAddedNotificatioMessage;
}

function getIncludeMostRecentAttachmentsInfoBarAction(
    itemId: ClientItemId,
    attachmentWell: AttachmentWellViewState,
    message: Message,
    infoBarAddHandler: (
        messageId: string,
        infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
    ) => void,
    infoBarRemoveHandler: (infoBarMessageIds: string[]) => void,
    updateActedComposeCallback: () => void,
    filterAttachmentsBasedOnAttachmentPolicy: (attachment) => boolean
): InfoBarCustomAction {
    const includeMostRecentAttachmentMessage: string =
        message.Attachments.length > 1
            ? loc(SuggestIncludeMostRecentAttachment_MultipleAttachmentsText)
            : loc(SuggestIncludeMostRecentAttachment_SingleAttachmentText);

    return {
        text: includeMostRecentAttachmentMessage,
        action: () => {
            updateActedComposeCallback();
            logUsage('AttachmentIncludeMostRecentAttachments');
            createAttachmentsFromRecentAttachments(
                itemId,
                attachmentWell,
                message.Attachments.filter(attachment =>
                    filterAttachmentsBasedOnAttachmentPolicy(attachment)
                ),
                infoBarAddHandler,
                infoBarRemoveHandler
            );
        },
    };
}
